export type MonoBankListItem = {
  name: string;
  bank_code: string;
  nip_code: string;
  direct_debit?: boolean;
  id?: string;
  icon?: string;
};

/** Collect `/mono/banks`: `{ data: { banks: [...] } }` or `{ data: [...] }` (Mono direct). */
export function parseMonoBanksResponse(response: unknown): MonoBankListItem[] {
  const body = response as { data?: unknown };
  const data = body?.data ?? response;
  if (Array.isArray(data)) {
    return data as MonoBankListItem[];
  }
  if (
    data &&
    typeof data === 'object' &&
    Array.isArray((data as { banks?: unknown }).banks)
  ) {
    return (data as { banks: MonoBankListItem[] }).banks;
  }
  return [];
}
